import { Divider, Typography, ListItemButton, styled } from '@mui/material'
import {
  getUserDisplayName,
  getUserFirstName,
  getUserFromUsersStorage,
  useUser,
} from '$logic/users'
import { getImageUrl } from '$func/imageUrl'
import { AvatarBase } from '$common/avatar/avatar-base'
import { stringToColor } from '$func/string-to-color'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { editorAPI } from '../text-editor'
import { MentionMenuItemSkeleton } from './mention-menu-item-skeleton'

const NameTypography = styled(Typography)`
  margin-right: 13px;
`
const UsernameTypography = styled(Typography)`
  margin-right: auto;
`

const StyledDivider = styled(Divider)`
  :last-child {
    display: none;
  }
`

export function MentionMenuItem({
  userId,
  imageCaptionMode,
}: {
  userId: string
  imageCaptionMode?: boolean
}) {
  const { user, loading } = useUser(userId)

  const onMentionItemClick = () => {
    getUserFromUsersStorage(userId).then(editorAPI.insertMention)
  }

  if (loading)
    return <MentionMenuItemSkeleton imageCaptionMode={imageCaptionMode} />

  if (!user) return null
  const avatarSrc = getImageUrl(user.image)
  const backgroundColor = stringToColor(getUserFirstName(user), user?.id)
  return (
    <>
      <ListItemButton
        disableGutters
        sx={{ display: 'flex', padding: '6px 15px 5px' }}
        onClick={onMentionItemClick}
      >
        <AvatarBase
          src={avatarSrc}
          size={AvatarSize.XS}
          backgroundColor={backgroundColor}
        />

        <NameTypography
          variant="paragraph3"
          color={imageCaptionMode ? 'white' : 'black'}
        >
          {getUserDisplayName(user)}
        </NameTypography>

        {user.username ? (
          <UsernameTypography
            variant="subtitle4"
            color={imageCaptionMode ? 'lightGray' : 'gray'}
          >
            {user.username}@
          </UsernameTypography>
        ) : null}
      </ListItemButton>

      <StyledDivider
        variant="inset"
        sx={{ borderColor: imageCaptionMode ? '#FFFFFF19' : 'inherit' }}
      />
    </>
  )
}

MentionMenuItem.defaultProps = {
  imageCaptionMode: false,
}
